import get from 'lodash/get';
import { USER_ROLES } from 'src/_shared/constants/userRolesEnum.js';
import { ml } from 'src/_shared/services/utils.js';

/**
 * The header's top-nav pages (Jobs, Announcements, custom pages) with the
 * company, role and platform-filter rules applied. The header renders them
 * as its horizontal menu; on phones, where that menu is hidden, the side
 * menu lists them instead (ERIN-8561).
 */
export const getHeaderNavItems = ({
	currentUser,
	customPageData = [],
	announcementCount,
	allMultiLingualData,
}) => {
	if (!currentUser) return [];
	const platformConfig = currentUser?.company?.platformConfig
		? JSON.parse(currentUser.company.platformConfig)
		: {
				primaryPlatform: 'referrals',
				filterMode: 'exclusionary',
				filterList: [],
			};
	const checkFiltered = (filteredPage) => {
		if (currentUser.role === USER_ROLES.SUPER_ADMIN) return false;
		return platformConfig?.filterList?.some((value) => value === filteredPage);
	};
	const hideJobsPage = get(currentUser, 'company.hideJobsPage', false);
	const disableExtendedUserJobsView = get(
		currentUser,
		'company.disableExtendedUserJobsView',
		false
	);
	const extendedUser = currentUser.role === USER_ROLES.EXTENDED_USER;

	const items = [];
	if (
		!checkFiltered('jobs') &&
		!hideJobsPage &&
		!(disableExtendedUserJobsView && extendedUser)
	) {
		items.push({
			key: 'BROWSE',
			title: ml('Jobs', currentUser, allMultiLingualData),
			link: '/browsejobs',
			iconType: 'magnifying-glass',
		});
	}
	if (!checkFiltered('announcements') && !extendedUser) {
		const label = ml('Announcements', currentUser, allMultiLingualData);
		items.push({
			key: 'ANNOUNCEMENTS',
			title: announcementCount != null ? `${label} (${announcementCount})` : label,
			link: '/announcements',
			iconType: 'announcements',
		});
	}
	if (!checkFiltered('customPages') && !extendedUser) {
		[...customPageData]
			.sort((a, b) => a.pageNumber - b.pageNumber)
			.filter((page) => page.active && !page.hideFromHeader)
			.forEach((page) => {
				items.push({
					key: `CUSTOMPAGE${page.pageNumber}`,
					title: page?.title || `Custom Page ${page.pageNumber}`,
					link: `/custompage/${page.pageNumber}`,
					iconType: 'customPage',
				});
			});
	}
	return items;
};
